import "./DropHighlight.css";

export function DropHighlight() {
  return <div className="drop-highlight" />;
}
